









































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { Equipe, UpdateEquipeModel } from "@/api/models/equipes/equipe";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-equipe",
})
export default class EditEquipe extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateEquipeSidebarActive!: boolean;
  @Prop({ required: true }) equipeId!: string;

  loading = false;
  required = required;
  loadingEquipe = false;



  equipe: UpdateEquipeModel = {};

  async created() {
    await this.$http.myressif.equipes
      .getById(this.equipeId)
      .then((res: Equipe) => {
        this.equipe = res;
        this.loadingEquipe = true;
      });
  }

  resetForm() {
    this.equipe = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.equipes
      .update(
        this.equipeId,
        this.equipe
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification de l'équipe",
            text: "Equipe modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-equipes");
        this.$emit("update:is-update-equipe-sidebar-active", false);
        this.loading = false;
      });
  }
}
